import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box } from '@mui/material';
import React from 'react';
export const AltchaBox = ({ icon, label }) => {
    return (React.createElement(Box, { sx: {
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            width: 260,
            p: '0.7rem',
            border: `1px solid ${themeColors.border.main}`,
            borderRadius: '4px',
            backgroundColor: themeColors.surface.primary,
        } },
        icon,
        React.createElement(Box, { sx: { color: themeColors.text.main } }, label)));
};
